import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.apiUrl}`;

class EventsService {
  getHeaders() {
    const token = localStorage.getItem("token") || "";
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  }

  async getEvents() {
    try {
      const response = await axios.get(
        `${BASE_URL}/events/others`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data?.reason || "Events fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.message ||
          "An error occurred while getting events",
      };
    }
  }
}
const eventsService = new EventsService();
export default eventsService;
